<template>
  <div id="modTreeAttributesHorizon">
    <div class="md-list-item-text">
      <div @click="ToggleList(attributeIndex)" class="btn title">
        <span>{{ (list_attributes[attributeIndex] && list_attributes[attributeIndex]['translation'])
        ? list_attributes[attributeIndex]['translation'] : ((attribute['translation']) ? attribute['translation'] :  attributeIndex)}}</span>
        <!-- <svg style="margin: 0px;  padding: 0px;  position: relative;  right: 20px;  width: 20px;  top: 3px;  color: #797979;"
          v-if="selectedFilters.includes(attributeIndex)"
          xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
          <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
        </svg> -->
        <!-- <svg v-else style="margin: 0px;  padding: 0px;  position: relative;  right: 20px;  width: 20px;  top: 3px;  color: #797979;"
        xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
          <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
        </svg> -->
      </div>
    </div>
    <!-- {{ attributeIndex }}
    {{ expandList }}

    {{ selectedFilters }} -->

    <template v-if="attribute['group'] && attribute['group'].length>0">
      <div class="md-item" v-if="selectedFilters.includes(attributeIndex)">

        <div class="md-item-group" v-for="attrGroup in attribute['group']" :key="attrGroup">
          <span class="md-item-group-title" v-if="list_attributes[attrGroup]['translation_short'] !== ''">
            {{ (list_attributes[attrGroup]['translation_short'] !== null) ? list_attributes[attrGroup]['translation_short'] :  attrGroup}}</span>

          <!-- jest group<br> -->

          <template v-if="list_attributes[attrGroup]['inputType'] == 'checkbox'">

              <!-- jest group if checkbox<br>
              {{ list_attributes[attrGroup]['translation'] }} -->
              <FormCheckBox
              :toggle="expandList.includes(attributeIndex)"
              :inputType="list_attributes[attrGroup]['inputType']"
              :params="list_attributes[attrGroup]['parametrs']"
              :tabName="attrGroup"
              :suffix="(list_attributes[attrGroup]['suffix']) ? list_attributes[attrGroup]['suffix'] : null"
              :parentTranslation="list_attributes[attrGroup]['translation']"
            />
          </template>
          <template v-if="list_attributes[attrGroup]['inputType'] == 'slider'">

            <!-- jest group if slider<br> -->

            <FormSlider
              :toggle="expandList.includes(attributeIndex)"
              :inputType="list_attributes[attrGroup]['inputType']"
              :params="list_attributes[attrGroup]['parametrs']"
              :tabName="attrGroup"
              :suffix="(list_attributes[attrGroup]['suffix']) ? list_attributes[attrGroup]['suffix'] : null"
              :interval="(list_attributes[attrGroup]['interval']) ? list_attributes[attrGroup]['interval'] : null"
              :parentTranslation="list_attributes[attrGroup]['translation']"
            />
          </template>
        </div>

      </div>
    </template>

    <template v-else>
      <div class="md-item" v-if="selectedFilters.includes(attributeIndex)">

        <!-- brak group<br> -->

        <template v-if="list_attributes[attributeIndex]['subgroup'] && Object.keys(list_attributes[attributeIndex]['subgroup']).length>0">

          <!-- jest subgroup<br> -->

          <FormCheckBoxGroups
            :toggle="expandList.includes(attributeIndex)"
            :subGroups="list_attributes[attributeIndex]['subgroup']"
            :tabName="attributeIndex"
            :inputType="list_attributes[attributeIndex]['inputType']"
            :suffix="(list_attributes[attributeIndex]['suffix']) ? list_attributes[attributeIndex]['suffix'] : null"
            :view="attributes_position"
            :parentTranslation="list_attributes[attributeIndex]['subgroup']['translation']"
          />
        </template>

        <template v-else>

          <!-- brak subgroup<br> -->

          <template v-if="list_attributes[attributeIndex]['inputType'] == 'checkbox'">

              <!-- brak subgroup checkbox<br> -->

              <FormCheckBox
              :toggle="expandList.includes(attributeIndex)"
              :inputType="list_attributes[attributeIndex]['inputType']"
              :params="list_attributes[attributeIndex]['parametrs']"
              :tabName="attributeIndex"
              :suffix="(list_attributes[attributeIndex]['suffix']) ? list_attributes[attributeIndex]['suffix'] : null"
            :parentTranslation="list_attributes[attributeIndex]['translation']"
            />
          </template>
          <template v-if="list_attributes[attributeIndex]['inputType'] == 'slider'">

            <!-- brak subgroup slider<br> -->

            <FormSlider
              :toggle="expandList.includes(attributeIndex)"
              :inputType="list_attributes[attributeIndex]['inputType']"
              :params="list_attributes[attributeIndex]['parametrs']"
              :tabName="attributeIndex"
              :suffix="(list_attributes[attributeIndex]['suffix']) ? list_attributes[attributeIndex]['suffix'] : null"
              :interval="(list_attributes[attributeIndex]['interval']) ? list_attributes[attributeIndex]['interval'] : null"
              :parentTranslation="list_attributes[attributeIndex]['translation']"
            />
          </template>
        </template>
      </div>
    </template>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FormCheckBox from './fields/FormCheckBox'
import FormSlider from './fields/FormSlider'
import FormCheckBoxGroups from './fields/FormCheckBoxGroups'

export default {
  name: "modTreeAttributesHorizon",
  props:['attributeIndex','attribute', 'expandList'],
  data() {
    return {
      view: false,
      isActive: true,
      complex: null,
      expand: {},
      expandSingle: false,
      // expandList: [],
      expandgroupList: [],
      group: '',
      moreOptions: false
    };
  },
  components: {
    FormCheckBox, FormSlider, FormCheckBoxGroups // Parametrs,
  },
  computed: {
    ...mapGetters('products', ['list_attributes','attributes_position','selectedFilters'])
  },
  methods: {
    ToggleList (item) {
      if (this.expandList.includes(item)) {
        const index = this.expandList.indexOf(item);
        if (index > -1) { // only splice array when item is found
          this.expandList.splice(index, 1); // 2nd parameter means remove one item only
        }
      } else {
        this.expandList.push(item)
      }
    },
    ToggleListGroup (item) {
      if (this.expandgroupList.includes(item)) {
        const index = this.expandgroupList.indexOf(item);
        if (index > -1) { // only splice array when item is found
          this.expandgroupList.splice(index, 1); // 2nd parameter means remove one item only
        }
      } else {
        this.expandgroupList.push(item)
      }
    },
    setGroup (gr) {
      this.group = gr
    },
    // changeListToggle (e) {
    //   if (e) {
    //     this.expandList = JSON.parse(JSON.stringify(this.selectedFilters))
    //   } else {
    //     this.expandList = []
    //   }
    // }
  }
}
</script>

<style>
.pos-horizon {
  overflow-y: auto;
}
#modTreeAttributesHorizon .md-list-item-text .btn span{
  color: white;
  background: #7b7b7b;
  padding: 4px 8px;
  font-weight: normal;
}

#modTreeAttributesHorizon .md-item-group .md-item-group-title {
  color: #a7a8a8;
  background: #eee;
  padding: 2px 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/modTreeAttributesHorizon.vue